// Generated by Melange

import * as Buhta_cabinet__NavLink from "../../html/NavLink.js";
import * as Buhta_cabinet__Route from "../../../Route.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import CatalogSvg from "static/icons/catalog.svg";
import DocumentsSvg from "static/icons/documents.svg";
import HomeSvg from "static/icons/home.svg";
import SettingsSvg from "static/icons/settings.svg";
import SkladSvg from "static/icons/sklad.svg";
import TaxesSvg from "static/icons/taxes.svg";

const activeItem = "flex py-1.5 lg:px-6 items-center hover:bg-white/8 sidebar__item lg:bg-white/8 text-white active__item";

const Styles = {
  activeItem: activeItem
};

function make(item) {
  return function (onCloseOpt) {
    const onClose = onCloseOpt !== undefined ? onCloseOpt : (function (param) {
          
        });
    return function (setBar) {
      const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
      const deviceType = state.deviceType;
      const isHidden = item.isHidden;
      const bar = item.bar;
      const eventName = item.eventName;
      const isActiveRoute = item.isActiveRoute;
      const route = item.route;
      const label = item.label;
      const match = React.useState(function () {
            return false;
          });
      const setIsHovered = match[1];
      const isHovered = match[0];
      const currentRoute = Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.useUrl(undefined));
      const isActiveRoute$1 = function (actualRoute) {
        if (typeof actualRoute === "number") {
          return false;
        }
        switch (actualRoute.TAG | 0) {
          case /* Org */6 :
              return Curry._1(isActiveRoute, actualRoute._1);
          case /* Admin */7 :
              const match = actualRoute._0;
              if (typeof match === "number") {
                return false;
              }
              if (match.TAG !== /* Orgs */1) {
                return false;
              }
              const match$1 = match._0;
              if (typeof match$1 === "number") {
                return false;
              } else {
                return Curry._1(isActiveRoute, match$1._1);
              }
          default:
            return false;
        }
      };
      let icon;
      let exit = 0;
      let org;
      if (typeof route === "number") {
        exit = 1;
      } else {
        switch (route.TAG | 0) {
          case /* Org */6 :
              org = route._1;
              exit = 2;
              break;
          case /* Admin */7 :
              const match$1 = route._0;
              if (typeof match$1 === "number" || match$1.TAG !== /* Orgs */1) {
                exit = 1;
              } else {
                const match$2 = match$1._0;
                if (typeof match$2 === "number") {
                  exit = 1;
                } else {
                  org = match$2._1;
                  exit = 2;
                }
              }
              break;
          default:
            exit = 1;
        }
      }
      switch (exit) {
        case 1 :
            icon = JsxRuntime.jsx(HomeSvg, {});
            break;
        case 2 :
            let exit$1 = 0;
            if (typeof org === "number") {
              exit$1 = 3;
            } else {
              switch (org.TAG | 0) {
                case /* Catalog */0 :
                    icon = JsxRuntime.jsx(CatalogSvg, {});
                    break;
                case /* Documents */1 :
                    icon = JsxRuntime.jsx(DocumentsSvg, {});
                    break;
                case /* Kassa */2 :
                    icon = JsxRuntime.jsx("img", {
                          className: "w-5 h-5",
                          src: StaticAsset.src(isHovered || isActiveRoute$1(currentRoute) ? "/static/icons/cashbox-white.svg" : "/static/icons/cashbox.svg")
                        });
                    break;
                case /* Sklad */3 :
                    icon = JsxRuntime.jsx(SkladSvg, {});
                    break;
                case /* Tax */4 :
                    icon = JsxRuntime.jsx(TaxesSvg, {});
                    break;
                case /* Hrm */5 :
                    icon = JsxRuntime.jsx("img", {
                          className: "w-5 h-5",
                          src: StaticAsset.src(isHovered || isActiveRoute$1(currentRoute) ? "/static/icons/people-white-20.svg" : "/static/icons/people-gray-20.svg")
                        });
                    break;
                case /* Payroll */6 :
                    if (org._0.TAG === /* Employees */0) {
                      icon = JsxRuntime.jsx("img", {
                            className: "w-5 h-5",
                            src: StaticAsset.src(isHovered || isActiveRoute$1(currentRoute) ? "/static/icons/wallet-20.svg" : "/static/icons/wallet-20-gray.svg")
                          });
                    } else {
                      exit$1 = 3;
                    }
                    break;
                case /* Manage */7 :
                    icon = JsxRuntime.jsx("img", {
                          className: "w-5 h-5",
                          src: isHovered || isActiveRoute$1(currentRoute) ? StaticAsset.src("/static/icons/books-white.svg") : StaticAsset.src("/static/icons/books.svg")
                        });
                    break;
                case /* Settings */8 :
                    icon = JsxRuntime.jsx(SettingsSvg, {});
                    break;
                
              }
            }
            if (exit$1 === 3) {
              icon = JsxRuntime.jsx(HomeSvg, {});
            }
            break;
        
      }
      return JsxRuntime.jsx("div", {
                  children: deviceType === "mobile" ? JsxRuntime.jsx(Buhta_components__Text.P.make, {
                          className: Cn.$plus("last:mt-auto text-gray-medium", Cn.on("hidden", isHidden)),
                          children: isActiveRoute$1(currentRoute) ? JsxRuntime.jsxs("button", {
                                  children: [
                                    JsxRuntime.jsx("div", {
                                          children: icon,
                                          className: "sidebar__item__icon"
                                        }),
                                    JsxRuntime.jsx("span", {
                                          children: label,
                                          className: Cn.fromList({
                                                hd: "ml-4",
                                                tl: /* [] */0
                                              })
                                        })
                                  ],
                                  className: "flex py-1.5 px-6 items-center bg-white/8 text-white active__item w-full",
                                  onClick: (function (param) {
                                      Curry._1(setBar, (function (param) {
                                              return bar;
                                            }));
                                    })
                                }) : JsxRuntime.jsxs(Buhta_cabinet__NavLink.make, {
                                  route: route,
                                  currentRoute: currentRoute,
                                  isActiveRoute: isActiveRoute$1,
                                  className: "flex py-1.5 px-6 items-center hover:bg-white/8 sidebar__item",
                                  activeClassName: activeItem,
                                  eventName: eventName,
                                  children: [
                                    JsxRuntime.jsx("div", {
                                          children: icon,
                                          className: "sidebar__item__icon"
                                        }),
                                    JsxRuntime.jsx("span", {
                                          children: label,
                                          className: Cn.fromList({
                                                hd: "ml-4",
                                                tl: /* [] */0
                                              })
                                        })
                                  ],
                                  onClose: onClose,
                                  bar: bar,
                                  setBar: setBar
                                })
                        }) : JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                          className: Cn.$plus("last:mt-auto text-gray-medium", Cn.on("hidden", isHidden)),
                          children: isActiveRoute$1(currentRoute) ? JsxRuntime.jsxs("button", {
                                  children: [
                                    JsxRuntime.jsx("div", {
                                          children: icon,
                                          className: "sidebar__item__icon"
                                        }),
                                    JsxRuntime.jsx("span", {
                                          children: label,
                                          className: Cn.fromList({
                                                hd: "ml-4",
                                                tl: /* [] */0
                                              })
                                        })
                                  ],
                                  className: "flex py-1.5 px-6 items-center lg:bg-white/8 text-white active__item w-full",
                                  onClick: (function (param) {
                                      Curry._1(setBar, (function (param) {
                                              return bar;
                                            }));
                                    })
                                }) : JsxRuntime.jsxs(Buhta_cabinet__NavLink.make, {
                                  route: route,
                                  currentRoute: currentRoute,
                                  isActiveRoute: isActiveRoute$1,
                                  className: "flex py-1.5 px-6 items-center hover:bg-white/8 sidebar__item",
                                  activeClassName: activeItem,
                                  eventName: eventName,
                                  children: [
                                    JsxRuntime.jsx("div", {
                                          children: icon,
                                          className: "sidebar__item__icon"
                                        }),
                                    JsxRuntime.jsx("span", {
                                          children: label,
                                          className: Cn.fromList({
                                                hd: "ml-4",
                                                tl: /* [] */0
                                              })
                                        })
                                  ],
                                  bar: bar,
                                  setBar: setBar
                                })
                        }),
                  onMouseEnter: (function (param) {
                      Curry._1(setIsHovered, (function (param) {
                              return true;
                            }));
                    }),
                  onMouseLeave: (function (param) {
                      Curry._1(setIsHovered, (function (param) {
                              return false;
                            }));
                    })
                });
    };
  };
}

function SidebarItem(Props) {
  return Curry._1(make(Props.item)(Props.onClose), Props.setBar);
}

const make$1 = SidebarItem;

export {
  Styles ,
  make$1 as make,
}
/* Buhta_cabinet__NavLink Not a pure module */
